<a (click)="redirect()" [ngClass]="getCssClass()" id="pending-order-btn">
  <div class="text-wrapper">
    <p>Cancelled order</p>
    <span>We’re sorry, we won’t be able to deliver your order as planned. If you don’t have a recurring booking or future booking, please rebook online, on our app or call our customer care line on 020 8004 2630.</span>
  </div>
  <div  class="icon arrow-right-red" id="arrow-red"></div>
</a>
